export {};
//# sourceMappingURL=impression-data-event.entity.js.map